// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container-pay-result[data-v-f3a01298] {\n  width: 100%;\n  height: 100vh;\n}\n.container-pay-result .content[data-v-f3a01298] {\n  width: 100%;\n  height: 100vh;\n  overflow: hidden;\n}\n.container-pay-result .content > img[data-v-f3a01298] {\n  width: 100%;\n  height: 100vh;\n  -o-object-fit: cover;\n     object-fit: cover;\n}\n", ""]);
// Exports
module.exports = exports;
